import React from 'react';
import {ColumnProps, RenderColumnProps} from '../..';
import {Container} from './styles';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';

interface Props {
  column: ColumnProps | string | RenderColumnProps;
  row: any;
  dataLabel: string;
  rowIndex: number;
}

const getNestedKey: any = (object: any, key: string) => {
  const [firstKey, ...rest] = key.split('.');

  if (rest.length === 0) return object?.[firstKey];
  return getNestedKey(object[firstKey], rest.join('.'));
};

const Column: React.FC<Props> = ({column, row, dataLabel, rowIndex}) => {
  if (typeof column === 'string')
    return (
      <Container data-label={dataLabel}>{getNestedKey(row, column)}</Container>
    );

  if (typeof column === 'function')
    return <Container>{column(row, rowIndex)}</Container>;

  const {isAllowed} = useAccessControls();
  const {value, clamp, permission, visible, stopPropagation} = column;

  if (permission && !isAllowed(permission)) return null;
  if (typeof visible === 'boolean' && !visible) return null;
  if (typeof visible === 'function' && !visible(row)) return null;

  return (
    <Container
      onClick={(e) => stopPropagation && e.stopPropagation()}
      data-label={dataLabel}
      {...{clamp}}>
      {typeof value === 'function'
        ? value(row, rowIndex)
        : typeof value === 'string'
        ? getNestedKey(row, value)
        : ''}
    </Container>
  );
};

export default Column;
